export default "__VITE_ASSET__Dhk3iX_$__"